export const products = [
  {
    id: 1,
    name: 'baoyu 旗舰版',
    slug: 'baoyu-flagship',
    category: 'flagship',
    description: 'baoyu 旗舰版是品牌旗下性能最强、功能最全面的高端产品，搭载全新一代智能核心，为您带来前所未有的极致体验。专为追求卓越品质的用户打造。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20luxury%20product%20with%20sleek%20modern%20design%2C%20white%20and%20warm%20gold%20accents%2C%20minimalist%20studio%20photography%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20elegant%20lifestyle%20product%20photography%2C%20high%20detail%20texture%2C%20premium%20quality%20feel&width=800&height=600&seq=baoyu-product-01&orientation=landscape',
    features: ['智能核心 3.0', '全天候续航', '专业级性能', 'AI 智能优化'],
    rating: 4.9,
    reviewCount: 2836,
  },
  {
    id: 2,
    name: 'baoyu 标准版',
    slug: 'baoyu-standard',
    category: 'standard',
    description: 'baoyu 标准版以出色的性价比著称，兼顾强大性能与优雅设计，是大多数用户的理想之选。日常使用流畅自然，轻松应对各种场景。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20product%20with%20minimalist%20design%2C%20warm%20cream%20and%20soft%20beige%20tones%2C%20clean%20studio%20photography%20on%20light%20neutral%20background%2C%20soft%20diffused%20lighting%2C%20lifestyle%20product%20photography%2C%20high%20quality%20texture%20detail&width=800&height=600&seq=baoyu-product-02&orientation=landscape',
    features: ['智能核心 2.0', '超长续航', '均衡性能', '多场景适配'],
    rating: 4.7,
    reviewCount: 5124,
  },
  {
    id: 3,
    name: 'baoyu 青春版',
    slug: 'baoyu-lite',
    category: 'lite',
    description: 'baoyu 青春版为年轻用户量身定制，轻巧便携，功能全面，以亲民的价格带来令人惊喜的体验。入门首选，轻松上手。',
    image: 'https://readdy.ai/api/search-image?query=Compact%20lightweight%20modern%20product%20with%20vibrant%20friendly%20design%2C%20soft%20pastel%20accents%20on%20cream%20white%2C%20clean%20studio%20photography%20on%20light%20neutral%20background%2C%20bright%20natural%20lighting%2C%20youthful%20lifestyle%20photography%2C%20high%20detail&width=800&height=600&seq=baoyu-product-03&orientation=landscape',
    features: ['轻巧便携', '持久续航', '流畅体验', '超高性价比'],
    rating: 4.6,
    reviewCount: 7831,
  },
  {
    id: 4,
    name: 'baoyu Pro Max',
    slug: 'baoyu-pro-max',
    category: 'flagship',
    description: 'baoyu Pro Max 是专业用户的终极装备，拥有无与伦比的运算能力和企业级安全防护，为高强度工作负载提供稳定可靠的支持。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20grade%20premium%20product%20with%20bold%20sophisticated%20design%2C%20dark%20charcoal%20and%20warm%20metallic%20accents%2C%20studio%20photography%20on%20clean%20warm%20background%2C%20dramatic%20soft%20lighting%2C%20enterprise%20product%20photography%2C%20premium%20build%20quality&width=800&height=600&seq=baoyu-product-04&orientation=landscape',
    features: ['企业级性能', '全天候防护', '专业工具套件', '7×24 支持'],
    rating: 5.0,
    reviewCount: 1256,
  },
  {
    id: 5,
    name: 'baoyu 联名限定款',
    slug: 'baoyu-collab',
    category: 'special',
    description: 'baoyu 与全球顶尖设计师联名打造的限定款，融合艺术美学与尖端科技，每一处细节都经过精心雕琢。限量发售，极具收藏价值。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20limited%20edition%20luxury%20product%20with%20unique%20designer%20aesthetics%2C%20warm%20gold%20and%20cream%20color%20palette%2C%20gallery%20style%20photography%20on%20soft%20neutral%20background%2C%20elegant%20dramatic%20lighting%2C%20collector%20item%20photography%2C%20exquisite%20detail&width=800&height=600&seq=baoyu-product-05&orientation=landscape',
    features: ['联名设计', '限量编号', '典藏礼盒', '专属服务'],
    rating: 4.8,
    reviewCount: 892,
  },
  {
    id: 6,
    name: 'baoyu 智能配件套装',
    slug: 'baoyu-accessories',
    category: 'accessories',
    description: 'baoyu 智能配件套装包含多款精心设计的配件，与 baoyu 产品无缝协作，拓展更多使用场景。品质与设计感兼具的必备良品。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tech%20accessories%20set%20with%20minimalist%20design%2C%20warm%20neutral%20tones%20cream%20and%20beige%2C%20flat%20lay%20photography%20on%20clean%20light%20background%2C%20soft%20natural%20lighting%2C%20lifestyle%20product%20photography%2C%20clean%20composition&width=800&height=600&seq=baoyu-product-06&orientation=landscape',
    features: ['无缝适配', '智能联动', '精致工艺', '多色可选'],
    rating: 4.5,
    reviewCount: 3402,
  },
];

export const categories = [
  { slug: 'all', name: '全部产品', icon: 'ri-apps-line' },
  { slug: 'flagship', name: '旗舰系列', icon: 'ri-vip-crown-line' },
  { slug: 'standard', name: '标准系列', icon: 'ri-star-line' },
  { slug: 'lite', name: '青春系列', icon: 'ri-sun-line' },
  { slug: 'special', name: '特别限定', icon: 'ri-vip-diamond-line' },
  { slug: 'accessories', name: '智能配件', icon: 'ri-bluetooth-line' },
];

export const articles = [
  {
    id: 1,
    slug: 'baoyu-2026-new-release',
    title: 'baoyu 2026 年度新品发布会全记录',
    excerpt: 'baoyu 在年度发布会上正式推出全新旗舰系列，以突破性技术创新再次定义行业标准。本文带你全面回顾发布会的精彩亮点与产品细节。',
    content: `2026年，baoyu 以一场震撼人心的发布会揭开了全新旗舰系列的神秘面纱。

本次发布会以「突破边界」为主题，baoyu 创始人兼 CEO 在开场致辞中分享了品牌过去一年的成长历程和未来愿景。过去一年，baoyu 在全球市场取得了令人瞩目的成绩，用户数量突破千万大关。

全新旗舰版搭载了革命性的智能核心 3.0 技术，对比上一代产品，性能提升了整整 200%。更令人兴奋的是，新品的能效比也得到了大幅优化，续航时间延长了 50%。

"我们不仅仅是在做一款产品，更是在为用户创造一种全新的生活方式。" CEO 在演讲中这样说道。

发布会上还展示了多款配件新品，构建起完整的 baoyu 生态系统。从智能配件套装到云端服务，baoyu 正在打造一个无缝连接的智能生活体验。

现场的媒体记者和合作伙伴对新产品给予了高度评价，纷纷表示 baoyu 再次证明了其在行业中的领导地位。

新品将于下月正式开售，首批用户还可享受限时优惠和专属礼遇。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20tech%20product%20launch%20event%20stage%20with%20dramatic%20lighting%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20professional%20event%20photography%2C%20large%20screen%20displaying%20product%2C%20excited%20atmosphere%2C%20corporate%20event%20photography%20style&width=1200&height=600&seq=baoyu-article-01&orientation=landscape',
    category: 'news',
    author: 'baoyu 官方',
    date: '2026-08-01',
    readTime: '8 分钟',
  },
  {
    id: 2,
    slug: 'baoyu-pro-max-deep-review',
    title: '深度评测：baoyu Pro Max 到底有多强？',
    excerpt: '经过长达一个月的深度体验，我们从性能、续航、设计、生态四个维度为你全面剖析 baoyu Pro Max，看它是否值得专业用户的期待。',
    content: `作为 baoyu 品牌旗下定位最高的专业级产品，Pro Max 自发布以来就备受关注。我们拿到这款产品已经整整一个月，现在为大家带来最详尽的深度评测。

首先来看外观设计。baoyu Pro Max 延续了品牌一贯的简约美学风格，机身采用航空级材质，手感扎实却不显笨重。细节处的打磨令人印象深刻，每一个倒角和接缝都处理得一丝不苟。

性能方面，Pro Max 搭载的企业级芯片展现了惊人的运算能力。在我们进行的多项基准测试中，它都遥遥领先于同级别竞品。无论是大型数据处理、复杂模型运算还是多任务并行，Pro Max 都能轻松应对。

续航表现同样出色。在我们的重度使用测试中，Pro Max 坚持了超过 12 个小时，这在同级别产品中是极为罕见的。更让人惊喜的是快充功能，仅需 30 分钟即可充至 80%。

安全防护是 Pro Max 区别于其他产品的重要特色。它配备了硬件级安全芯片和多重生物识别技术，为企业用户提供了全方位的安全保障。

综合来看，baoyu Pro Max 确实是一款不负「专业」之名的旗舰产品。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20tech%20product%20detailed%20review%20photography%2C%20premium%20product%20on%20minimalist%20desk%20setup%2C%20warm%20cream%20and%20charcoal%20tones%2C%20clean%20workspace%20aesthetic%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography&width=1200&height=600&seq=baoyu-article-02&orientation=landscape',
    category: 'review',
    author: '科技观察员',
    date: '2026-07-28',
    readTime: '12 分钟',
  },
  {
    id: 3,
    slug: 'baoyu-ecosystem-guide',
    title: '玩转 baoyu 生态：从入门到精通的完整指南',
    excerpt: '想要充分发挥 baoyu 产品的潜力？这篇生态指南将带你系统了解 baoyu 的全套产品线和配件生态，让你真正掌握 baoyu 的使用精髓。',
    content: `baoyu 不仅仅是一款单一产品，更是一套完整的智能生态系统。本文将从零开始，带你全面了解 baoyu 生态的每一个组成部分。

baoyu 的核心理念是「无缝连接」。无论你使用哪款 baoyu 产品，都可以轻松地与配件、云端服务以及其他 baoyu 设备进行联动。这种深度整合带来了远超单品使用的体验提升。

首先推荐的是 baoyu 智能配件套装。它包含多款精心设计的配件，从保护壳到扩展模块，每一件都与 baoyu 产品完美适配。特别是智能扩展模块，能够根据不同的使用场景自动切换模式，大大提升了使用效率。

云端同步是 baoyu 生态的另一大亮点。通过 baoyu Cloud 服务，你可以在所有设备之间无缝同步数据。无论是在旗舰版上开始的工作，还是用青春版查看的信息，都能做到即时同步、无缝衔接。

对于追求极致体验的用户，我们还推荐搭配 baoyu 专属的智能家居控制中心。通过它，你可以用 baoyu 设备轻松控制家中的智能设备，真正实现智能生活。

希望这篇指南能帮助你更好地使用 baoyu 产品。如果你有任何问题，欢迎在评论区留言讨论。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20tech%20ecosystem%20product%20family%20flat%20lay%2C%20multiple%20elegant%20devices%20arranged%20harmoniously%2C%20warm%20cream%20and%20soft%20gold%20color%20palette%2C%20clean%20minimalist%20composition%20on%20light%20background%2C%20lifestyle%20tech%20photography&width=1200&height=600&seq=baoyu-article-03&orientation=landscape',
    category: 'guide',
    author: 'baoyu 产品团队',
    date: '2026-07-20',
    readTime: '15 分钟',
  },
  {
    id: 4,
    slug: 'baoyu-user-story-2026',
    title: 'baoyu 用户的真实故事：从日常到非凡',
    excerpt: '我们采访了三位不同行业的 baoyu 用户，听听他们如何用 baoyu 产品改变工作和生活方式，这些真实故事或许能给你带来启发。',
    content: `在 baoyu，我们始终相信产品的价值来自于用户的实际体验。这次我们邀请了三位于不同领域的 baoyu 用户，分享他们与 baoyu 的故事。

第一位是自由摄影师小林。她使用 baoyu 旗舰版处理大量高分辨率照片。"以前修一组照片要花半天时间，用 baoyu 旗舰版之后，效率提升了至少三倍。色彩还原度也让我非常满意，在户外也能准确判断照片效果。"

第二位受访者是创业公司 CTO 张先生。他的团队全员配备了 baoyu Pro Max。"对于我们这样的技术团队来说，稳定性和安全性是第一位的。baoyu Pro Max 的企业级安全防护让我们非常放心，而且性能足够支撑我们的开发需求。"

第三位是大学生小王。她选择的是 baoyu 青春版。"作为学生，预算有限但又不愿意在品质上妥协。baoyu 青春版完美满足了我的需求，上课记笔记、看资料、追剧都很流畅，续航也够用一整天。"

三位用户来自不同背景，有着不同的需求，但他们都找到了属于自己的 baoyu。这正是 baoyu 品牌一直以来的追求——为每一个用户提供最适合的选择。

如果你也有 baoyu 的使用故事想分享，欢迎通过我们的官方渠道投稿。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20lifestyle%20photography%20of%20diverse%20people%20using%20modern%20tech%20products%20in%20different%20settings%2C%20cozy%20cafe%20office%20and%20campus%20scenes%2C%20cream%20and%20warm%20neutral%20tones%2C%20natural%20lighting%2C%20authentic%20editorial%20style&width=1200&height=600&seq=baoyu-article-04&orientation=landscape',
    category: 'story',
    author: 'baoyu 编辑部',
    date: '2026-07-15',
    readTime: '10 分钟',
  },
  {
    id: 5,
    slug: 'baoyu-lite-vs-standard',
    title: 'baoyu 青春版 vs 标准版：哪款更适合你？',
    excerpt: '青春版和标准版是 baoyu 最受欢迎的两款产品，本文从价格、性能、续航、适用场景四个维度进行详细对比，帮你做出明智选择。',
    content: `对于很多准备入手 baoyu 的用户来说，青春版和标准版之间的选择是一个甜蜜的烦恼。两款产品各有特色，本文帮你理清楚。

价格方面，青春版显然更具优势，比标准版低了约 30%。对于预算敏感的用户，青春版无疑是最佳入门之选。

性能对比上，标准版搭载了智能核心 2.0，在处理复杂任务时表现更从容。青春版的智能核心 1.0 在日常使用中同样流畅，但在专业应用场景下会稍显吃力。

续航是青春版的强项。由于采用了更节能的配置，青春版在轻度使用下可以坚持更长时间。标准版虽然续航略短，但考虑到其更强的性能，这个差距完全可以接受。

适用场景方面，如果你主要用 baoyu 进行内容消费、日常办公和学习，青春版完全够用。如果你需要处理更复杂的任务，比如视频剪辑或大型文档处理，建议选择标准版。

总的来说，青春版更适合学生和轻度用户，标准版则适合对性能有一定要求的职场人士。两款都是非常优秀的产品，选择哪款主要取决于你的实际需求。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20elegant%20modern%20tech%20products%20side%20by%20side%20comparison%2C%20minimalist%20studio%20setup%2C%20warm%20cream%20and%20soft%20beige%20background%2C%20clean%20product%20photography%2C%20soft%20diffused%20lighting%2C%20comparison%20editorial%20style&width=1200&height=600&seq=baoyu-article-05&orientation=landscape',
    category: 'guide',
    author: 'baoyu 产品团队',
    date: '2026-07-10',
    readTime: '7 分钟',
  },
  {
    id: 6,
    slug: 'baoyu-security-whitepaper',
    title: 'baoyu 安全白皮书：我们如何保护你的数据',
    excerpt: '数据安全是 baoyu 的重中之重。本文详细介绍 baoyu 的多层安全防护体系，让你了解品牌在隐私保护方面的坚定承诺与技术实践。',
    content: `在数字化时代，数据安全已经成为每个用户最关心的话题之一。baoyu 始终将用户数据安全放在首位，构建了一套完善的多层防护体系。

硬件层面，baoyu 全系产品都配备了独立安全芯片，用于存储最敏感的密钥和生物识别数据。这些数据永远不会离开安全芯片，即使设备被物理攻击也无法被窃取。

系统层面，baoyu 采用了最新的端到端加密技术。所有在 baoyu 设备之间传输的数据都经过加密处理，确保在传输过程中不会被第三方截获。

云端安全同样不容忽视。baoyu Cloud 通过了多项国际安全认证，包括 ISO 27001 和 SOC 2 Type II。所有存储在云端的数据都经过 AES-256 加密，并且用户可以随时查看和管理自己的数据。

在合规方面，baoyu 严格遵守全球各地的数据保护法规，包括 GDPR 和中国的《个人信息保护法》。我们定期接受第三方安全审计，确保安全措施始终处于行业领先水平。

安全不是一句口号，而是 baoyu 对每一位用户的郑重承诺。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20cybersecurity%20concept%20with%20elegant%20shield%20and%20lock%20visual%20metaphor%2C%20warm%20cream%20and%20dark%20charcoal%20tones%2C%20clean%20minimalist%20design%2C%20soft%20gradient%20lighting%2C%20corporate%20tech%20security%20photography%20style&width=1200&height=600&seq=baoyu-article-06&orientation=landscape',
    category: 'news',
    author: 'baoyu 安全团队',
    date: '2026-07-05',
    readTime: '9 分钟',
  },
];

export const reviews = [
  {
    id: 1,
    name: '陈先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20portrait%20headshot%2C%20warm%20friendly%20expression%2C%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20corporate%20portrait%20photography&width=80&height=80&seq=baoyu-avatar-01&orientation=squarish',
    role: '企业管理者',
    rating: 5,
    content: '使用 baoyu 旗舰版已经半年了，效率提升非常明显。以前需要一整天处理的工作，现在半天就能完成。产品做工精细，系统流畅稳定，售后服务也很及时。强烈推荐给追求品质的朋友。',
    date: '2026-08-05',
  },
  {
    id: 2,
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20woman%20portrait%20headshot%2C%20warm%20confident%20expression%2C%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20corporate%20portrait%20photography&width=80&height=80&seq=baoyu-avatar-02&orientation=squarish',
    role: '自由设计师',
    rating: 5,
    content: '作为一个对色彩要求极高的设计师，baoyu 的屏幕表现让我非常惊喜。色准极高，长时间工作眼睛也不容易疲劳。Pro Max 的性能处理大型设计文件毫无压力，是我用过最顺手的工具。',
    date: '2026-08-02',
  },
  {
    id: 3,
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20student%20portrait%20headshot%2C%20friendly%20smile%2C%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20youthful%20portrait%20photography&width=80&height=80&seq=baoyu-avatar-03&orientation=squarish',
    role: '在校大学生',
    rating: 4,
    content: '作为学生党，baoyu 青春版的价格真的很友好。日常上课记笔记、看文献、偶尔玩玩游戏都够用。续航特别棒，一天课下来完全不用充电。外观也很好看，同学们都问我是什么牌子。',
    date: '2026-07-30',
  },
  {
    id: 4,
    name: '赵总监',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Asian%20man%20portrait%20headshot%2C%20professional%20expression%2C%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20corporate%20portrait%20photography&width=80&height=80&seq=baoyu-avatar-04&orientation=squarish',
    role: '技术总监',
    rating: 5,
    content: '团队全员换装 baoyu Pro Max 之后，整体开发效率提升了不少。企业级安全防护让我们在处理敏感数据时更加放心。IT 管理也变得简单了，统一部署和维护都很方便。',
    date: '2026-07-25',
  },
  {
    id: 5,
    name: '孙女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20woman%20portrait%20headshot%2C%20elegant%20warm%20expression%2C%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20corporate%20portrait%20photography&width=80&height=80&seq=baoyu-avatar-05&orientation=squarish',
    role: '自媒体博主',
    rating: 5,
    content: 'baoyu 联名限定款真的太美了！不光是颜值高，用起来也很顺手。拍视频、剪视频都很流畅，一天下来电量还有剩余。限量的编号也让我感觉特别有仪式感。',
    date: '2026-07-20',
  },
];

export const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: 'baoyu 采用多层安全防护体系，硬件级加密芯片配合端到端加密技术，全方位守护你的数据安全与隐私。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极致性能',
    description: '全新智能核心引擎为 baoyu 注入强大动力，无论是日常办公还是专业创作，都能享受流畅无缝的体验。',
  },
  {
    icon: 'ri-battery-2-line',
    title: '超长续航',
    description: 'baoyu 的智能功耗管理技术让你摆脱充电焦虑，全天候陪伴，从容应对每一个重要时刻。',
  },
  {
    icon: 'ri-palette-line',
    title: '美学设计',
    description: 'baoyu 将简约美学融入每一处细节，精致的工艺与优雅的线条，让你的品味由内而外地展现。',
  },
];

export const stats = [
  { value: '1000万+', label: '全球活跃用户' },
  { value: '50+', label: '国家和地区覆盖' },
  { value: '99.7%', label: '用户满意度' },
  { value: '200+', label: '核心技术专利' },
];

export const faqs = [
  {
    question: 'baoyu 产品支持哪些售后服务？',
    answer: 'baoyu 全系产品均享受 2 年官方质保服务，包含免费硬件维修和专业技术支持。我们还提供 7×24 小时在线客服，随时为你解答使用中的问题。旗舰系列用户还可享受专属上门服务。',
  },
  {
    question: 'baoyu 不同版本之间有什么区别？',
    answer: 'baoyu 目前有旗舰版、标准版、青春版和 Pro Max 四个主要版本。旗舰版性能最强、功能最全；标准版性价比出色、适合大多数用户；青春版轻巧便携、价格亲民；Pro Max 面向专业用户、拥有企业级性能和安全防护。你可以根据自己的需求和预算选择最合适的版本。',
  },
  {
    question: 'baoyu 产品之间可以数据互通吗？',
    answer: '当然可以。baoyu 全系产品都支持 baoyu Cloud 云端同步服务，只要登录同一个 baoyu 账号，所有设备之间的数据都能无缝同步。你可以随意在不同设备间切换使用，享受一致流畅的体验。',
  },
  {
    question: 'baoyu 有什么购买渠道？',
    answer: 'baoyu 产品可以通过官方网站、授权电商平台以及线下体验店购买。官方渠道购买的用户可享受完整的质保服务和售后支持。我们也经常推出限时优惠活动，关注官方动态不错过每一个好机会。',
  },
  {
    question: 'baoyu 青春版适合学生使用吗？',
    answer: '非常适合。baoyu 青春版正是为学生群体量身打造的。它拥有出色的续航能力、轻巧便携的设计和亲民的价格，无论是上课记笔记、看资料还是课后娱乐，都能完美胜任。很多高校学生都选择了 baoyu 青春版作为他们的学习伙伴。',
  },
];